// extracted by mini-css-extract-plugin
export default {"wrapper":"SuccessModal_wrapper__FmV+y","appear":"SuccessModal_appear__PI7hg","openTop":"SuccessModal_openTop__gtVqU"};